<forge-banner *ngIf="(outage$ | async)" [theme]="outageStatusService.bannerType" density="dense"
  style="display:block; margin-bottom:1rem;">
  {{ outageStatusService.outageMessage }}
</forge-banner>
<forge-page-state>
  <img slot="graphic" [src]="graphicSrc" alt="" />
  <div slot="title">{{title}}</div>
  <p slot="message">{{message}}</p>
  <forge-button variant="raised" (click)="onBackBtnClick()" aria-label="Go back" slot="action"
    *ngIf="backButtonEnabled">
    Go back
  </forge-button>
  <forge-button variant="outlined" (click)="handleRefreshButtonClicked()" aria-label="Refresh" slot="action"
    *ngIf="refreshButtonEnabled">
    Refresh
  </forge-button>
</forge-page-state>